import { ArticleTypeStore } from './article-type.store';
import { Injectable } from '@angular/core';
import { BaseQuery } from "../base/base.query";

@Injectable({ providedIn: 'root' })
export class ArticleTypeQuery extends BaseQuery {

    constructor(store: ArticleTypeStore) {
        super(store);
    }
}
